import React from "react";
import { Stack, Typography } from "@mui/material";

function NotFound() {
  return (
    <Stack
      width="100%"
      height="100vh"
      alignItems="center"
      justifyContent="center"
      gap={2}
    >
      <Typography variant="h1" sx={{ color: "grey" }}>
        Opps
      </Typography>
      <Typography variant="h6" sx={{ color: "grey" }}>
        Page Not Found
      </Typography>
    </Stack>
  );
}

export default NotFound;
